import { render, staticRenderFns } from "./TrainingsListItemChapters.vue?vue&type=template&id=2e8e1d14&scoped=true"
import script from "./TrainingsListItemChapters.vue?vue&type=script&lang=js"
export * from "./TrainingsListItemChapters.vue?vue&type=script&lang=js"
import style0 from "./TrainingsListItemChapters.vue?vue&type=style&index=0&id=2e8e1d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e1d14",
  null
  
)

export default component.exports